export default __webpack_public_path__ + "static/media/rubik-v12-latin-700.fef4ed5c.woff";